"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApmsStorage = exports.supportLocalstorage = void 0;
exports.supportLocalstorage = typeof ((_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem) === 'function' &&
    typeof window.localStorage.setItem === 'function';
var ApmsStorage = (function () {
    function ApmsStorage(config) {
        this.prefix = 'mdap';
        this.prefix = config.name;
    }
    ApmsStorage.prototype.getStorageKey = function (key) {
        if (!exports.supportLocalstorage) {
            return;
        }
        var storageKey = key;
        var prefixRegex = new RegExp('^' + this.prefix);
        if (!prefixRegex.test(key)) {
            storageKey = this.prefix + "_" + key;
        }
        return storageKey;
    };
    ApmsStorage.prototype.setObject = function (key, value) {
        if (!exports.supportLocalstorage) {
            return;
        }
        try {
            var formatValue = typeof value === 'string' ? value : JSON.stringify(value);
            var storageKey = this.getStorageKey(key);
            if (storageKey) {
                localStorage.setItem(storageKey, formatValue);
            }
        }
        catch (error) {
        }
    };
    ApmsStorage.prototype.getObject = function (key) {
        if (!exports.supportLocalstorage) {
            return;
        }
        try {
            var storageKey = this.getStorageKey(key);
            var value = localStorage.getItem(storageKey);
            if (!value) {
                return undefined;
            }
            var result = JSON.parse(value);
            return result;
        }
        catch (error) {
        }
        return undefined;
    };
    ApmsStorage.prototype.getKeys = function () {
        if (!exports.supportLocalstorage) {
            return;
        }
        var keys = [];
        var length = localStorage.length;
        var prefixRegex = new RegExp('^' + this.prefix);
        for (var i = 0; i < length; i++) {
            var key = localStorage.key(i);
            if (key && prefixRegex.test(key)) {
                keys.push(key);
            }
        }
        return keys;
    };
    ApmsStorage.prototype.removeItem = function (key) {
        if (!exports.supportLocalstorage) {
            return;
        }
        var storageKey = this.getStorageKey(key);
        localStorage.removeItem(storageKey);
    };
    ApmsStorage.prototype.clear = function () {
        var _a;
        if (!exports.supportLocalstorage) {
            return;
        }
        var keys = (_a = this.getKeys()) !== null && _a !== void 0 ? _a : [];
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            localStorage.removeItem(key);
        }
    };
    return ApmsStorage;
}());
exports.ApmsStorage = ApmsStorage;
